// extracted by mini-css-extract-plugin
export default {"card":"Card_card__SveKy","name":"Card_name__1G09Y","jobtitle":"Card_jobtitle__7awXs","description":"Card_description__kMdDq"};